export const mobileViewport = () => window.innerWidth < 640;